<template>
  <div class="page-container" :class="{ 'page-container--with-sidebar': isSidebarPresent }">
    <entity-table
      :columns="columns"
      :items="userGroups"
      :are-items-clickable="false"
      :is-loaded="!!numberOfPages"
      title="Skupine"
      search-text="Išči po skupinah"
      add-text="Dodaj skupino"
      :empty-text="emptyText"
      :pagination="pagination"
      @page-change="goToPage"
      @search="setQuery"
      @add="openCreateUserGroup"
    >
      <template #actions="actionsProps">
        <md-table-cell class="actions-cell">
          <icon name="edit" @click="openEditUserGroup(actionsProps.item)" />
          <v-tooltip>Uredi</v-tooltip>
        </md-table-cell>
        <md-table-cell class="actions-cell">
          <icon name="trash" @click="openDeleteUserGroup(actionsProps.item)" />
          <v-tooltip>Izbriši</v-tooltip>
        </md-table-cell>
      </template>
    </entity-table>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import EntityTable from '@/components/shared/EntityTable'
import Icon from 'design-system/icons/Icon.vue'
import VTooltip from 'design-system/VTooltip.vue'
import PaginationMixin from '../../shared/PaginationMixin'
import prompt from 'design-system/components/prompt/prompt'

export default {
  components: {
    EntityTable,
    VTooltip,
    Icon,
  },
  mixins: [PaginationMixin],
  beforeCreate () {
    this.columns = [
      { id: 'name', name: 'Ime' },
      { id: 'membershipsCount', name: 'Število članov' },
      { id: 'createdAt', name: 'Datum ustvarjanja' },
    ]
  },
  data () {
    return {
      showManageMembersDialog: false,
      selectedUserGroup: null,
    }
  },
  created () {
    this.initialize()
    this.storeModule = ['accountStore', 'userGroups']
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState('accountStore/userGroups', ['numberOfPages', 'query']),
    ...mapGetters(['accountSlug']),
    ...mapGetters('accountStore/userGroups', ['userGroups']),
    emptyText () {
      return this.query ? 'Nobena skupina ne ustreza iskanju.' : 'Zaenkrat še nimate skupin uporabnikov.'
    },
  },
  methods: {
    ...mapActions('accountStore/userGroups', ['initialize', 'reset', 'setQuery', 'goToPage']),
    openCreateUserGroup () {
      this.$router.push({
        name: 'account_user_group_create_path',
        params: {
          accountId: this.accountSlug,
        },
      })
    },
    openEditUserGroup (userGroup) {
      this.$router.push({
        name: 'account_user_group_edit_path',
        params: {
          id: userGroup.id,
          accountId: this.accountSlug,
        },
      })
    },
    async openDeleteUserGroup (userGroup) {
      this.selectedUserGroup = userGroup
      const result = await prompt.okText('Izbriši').confirm(`Res želite izbrisati skupino "${userGroup.name}"? Vsi dokumenti v tej skupini bodo preneseni v skupno rabo računa.`)
      if (result) {
        this.deleteUserGroup()
      }
    },
    async deleteUserGroup () {
      if (this.selectedUserGroup) {
        try {
          await this.$store.dispatch('accountStore/userGroups/deleteUserGroup', this.selectedUserGroup.id)
          this.initialize()
        } catch (error) {
          console.error('Error deleting user group:', error)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/common';
@import '@/components/clickable_table_actions';

.dialog-content {
  padding: 20px;
  max-width: 400px;

  h3 {
    margin: 0 0 16px 0;
    font-size: 18px;
    font-weight: 600;
  }

  p {
    margin: 0 0 20px 0;
    line-height: 1.5;
  }
}

.dialog-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.actions-cell {
  ::v-deep .md-table-cell-container {
    padding: 8px;
  }
}
</style>
